const getInitialCategoryId = initData => {
    let id = 0;
    if (initData.categoryPath && initData.categoryPath.length > 0) {
        initData.categoryPath.forEach(item => {
            if (item.selected) {
                id = item.id;
            }
        });
    }
    return id;
};

export default initData => {
    return {
        type: initData.pageName || null,
        categoryPath: initData.categoryPath || [],
        allCategories: initData.allCategories || [],
        currentCategoryId: getInitialCategoryId(initData),
        metaTitle: '',
        metaDescription: '',
        metaRobots: '',
        canonicalLink: '',
        breadcrumbs: ''
    };
};
